import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API, authFetch } from '../utils/api';
import { MalsoPreview, MalsoCertPreview, MyunjangPreview, ContractPreview, NonBizPreview, PumuiPreview } from './DocumentPreviews';

function DocViewPage({onStatusChange}){
  var { carId, docType } = useParams();
  var [car, setCar] = useState(null);
  var [loading, setLoading] = useState(true);
  var [printed, setPrinted] = useState(false);
  var navigate = useNavigate();

  useEffect(function(){
    fetch(API + '/cars/' + carId).then(function(r){return r.json()}).then(function(d){
      if(d){setCar(d);setLoading(false);}else{navigate('/main/car-list');}
    }).catch(function(){navigate('/main/car-list');});
  }, [carId]);

  if(loading || !car) return <div style={{padding:40,textAlign:'center'}}>⏳ 로딩 중...</div>;

  var now=new Date();var yy=now.getFullYear();var mo=now.getMonth()+1;var dy=now.getDate();
  var ip=(car.ownerId||'').split('-');var iF=ip[0]||'';var iB=ip.slice(1).join('-')||'';
  var pr=function(){
    var co=document.getElementById('dpa2').innerHTML;
    var w=window.open('','_blank');
    w.document.write('<html><head><title>출력</title><style>body{font-family:"맑은 고딕",sans-serif;font-size:12px;color:#000;margin:30px 40px;line-height:1.6}table{border-collapse:collapse;width:100%}td,th{border:1px solid #000;padding:6px 10px;font-size:11px;vertical-align:middle}@media print{@page{size:A4;margin:15mm}}</style></head><body>'+co+'</body></html>');
    w.document.close();
    setTimeout(function(){w.print()},300);
    // 말소신청서 출력 시 → 말소신청 단계로
    if(docType==='malso' && car.status==='등록완료'){
      authFetch(API+'/cars/'+car.id+'/status',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({status:'말소신청'})})
        .then(function(){setPrinted(true);if(onStatusChange)onStatusChange('말소신청');});
    }
  };
  return(
    <div>
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:16}}>
        <button className="btn btn-outline" onClick={function(){navigate('/main/car-list')}}>← 목록</button>
        <div style={{display:'flex',gap:8,alignItems:'center'}}>
          <span style={{background:'#eff6ff',padding:'6px 14px',borderRadius:20,fontSize:12,fontWeight:700,color:'#2563eb'}}>🚗 {car.carNo}</span>
          {printed&&<span style={{background:'#dcfce7',color:'#16a34a',padding:'4px 10px',borderRadius:12,fontSize:11,fontWeight:700}}>✅ 말소신청 단계 진입!</span>}
          <button className="btn btn-blue" onClick={pr}>🖨️ {docType==='malso'&&car.status==='등록완료'?'출력 (말소신청 진입)':'출력'}</button>
        </div>
      </div>
      <div className="card" style={{maxWidth:800,margin:'0 auto',padding:40}}>
        <div id="dpa2">
          {docType==='malso'&&<MalsoPreview cn={car.carNo} vi={car.vin} ct={car.carType} u2={car.usage2} ow={car.owner} oa={car.ownerAddr} oi={iF} oib={iB} ml={car.mileage} yy={yy} mo={mo} dy={dy}/>}          {docType==='malsoCert'&&<MalsoCertPreview cn={car.carNo} vi={car.vin} ct={car.carType} ow={car.owner} oa={car.ownerAddr} oi={iF} oib={iB} ml={car.mileage}/>}
          {docType==='myunjang'&&<MyunjangPreview cn={car.carNo} vi={car.vin} ct={car.carType} ow={car.owner} oa={car.ownerAddr} oi={iF} oib={iB} rd={car.regDate} ml={car.mileage}/>}           {docType==='contract'&&<ContractPreview cn={car.carNo} vi={car.vin} ct={car.carType} ow={car.owner} oa={car.ownerAddr} oi={iF} oib={iB} bp={car.buyPrice} cp="" bl="" bu={null} companyId={car.companyId} autoOwnerSeal={car.auto_owner_seal!==0}/>}
          {docType==='nonbiz'&&<NonBizPreview cn={car.carNo} ct={car.carType} ow={car.owner} oi={iF} oib={iB}/>}
          {docType==='pumui'&&<PumuiPreview cn={car.carNo} vi={car.vin} ct={car.carType} u2={car.usage2} ow={car.owner} oa={car.ownerAddr} oi={iF} oib={iB} rd={car.regDate} ml={car.mileage} bp={car.buyPrice}/>}
        </div>
      </div>
    </div>
  );
}

export default DocViewPage;
